import React from "react"
import moment from "moment"
import { flowRight as compose } from "lodash"
import { Card, CardBody } from "reactstrap"
import { useQuery } from "@apollo/react-hooks"
import withModal from "components/modal"
import { Spinner } from "components/spinner"
import { withBreadcrumb, useBread } from "components/breadcrumb"
import { GET_TABLE_FIELDS } from "../../announcement/gql"
import { GET_ORDER_HISTORIES, SUM_ORDER_HISTORIES } from "../gql"
import { CustomServerSideReactTableNew } from "../../../components/utility"

document.body.scrollTop = 0 // For Safari
document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

const OrderHistoryContainer = (props) => {
  useBread({ to: props.match.url, name: "訂單修改記錄" }, true)

  const columnDefs = [
    { title: "巨研訂單編號", name: "orderNumber", type: "input" },
    { title: "描述", name: "description", type: "input" },
    { title: "公司名稱", name: "companyName", type: "input" },
    { title: "訂單擁有者", name: "userName", type: "input" },
    { title: "更新者", name: "creatorName", type: "input" },
    {
      title: "維護時間",
      name: "createdAt",
      type: "date"
    }
  ]

  const fieldsDefinition = () => {
    return [
      {
        id: "orderNumber",
        Header: "巨研訂單編號",
        style: columStyle,
        accessor: (data) => data.order?.orderNumber,
        Cell: (cell) => {
          return <div>{cell.row.orderNumber || "未成立之訂單"}</div>
        }
      },
      {
        Header: "描述",
        style: columStyle,
        accessor: "description"
      },
      {
        id: "companyName",
        Header: "公司名稱",
        style: columStyle,
        accessor: (data) => data.order?.company?.name,
        Cell: (cell) => {
          return <div>{cell.row.companyName}</div>
        }
      },
      {
        id: "user",
        Header: "訂單擁有者",
        style: columStyle,
        accessor: (data) => data.order?.user?.name,
        Cell: (cell) => {
          return <div>{cell.row.user}</div>
        }
      },
      {
        id: "creator",
        Header: "建立者",
        style: columStyle,
        width: 150,
        accessor: (data) => data.creator?.name,
        Cell: (cell) => {
          return <div>{cell.row.creator}</div>
        }
      },
      {
        id: "createdAt",
        Header: "維護時間",
        style: columStyle,
        accessor: (data) => moment(data.createdAt).format("YYYY-MM-DD a h:mm")
      }
    ]
  }

  return (
    <CustomServerSideReactTableNew
      columnDefs={columnDefs}
      queryObjectGql={GET_ORDER_HISTORIES}
      sumTotalQueryObjectGql={SUM_ORDER_HISTORIES}
      fieldsDefGql={GET_TABLE_FIELDS}
      objectRoute={props.match.url}
      fieldsDef={fieldsDefinition()}
    />
  )
}
const columStyle = { whiteSpace: "unset", textAlign: "center" }

export default compose(withBreadcrumb, withModal)(OrderHistoryContainer)
